module.exports = __webpack_public_path__ + "static/media/nat-2.4d378368.jpg";